export function onCF7MailSent() {
  const inputToFocus = $(this).find('.wpcf7-response-output');
  if (!inputToFocus.length) {
    return;
  }

  setTimeout(() => {
    inputToFocus.css('display', 'block');
    const offset = inputToFocus.offset().top;
    inputToFocus.css('display', '');

    $([document.documentElement, document.body]).animate(
      {
        scrollTop: offset - 300,
      },
      1000,
    );

    inputToFocus.first().focus();
  }, 500);
}

function scrollOnSuccess() {
  const forms = $('form.wpcf7-form');

  if (!forms.length) return true;

  forms.each(function () {
    // handle success
    $(this).parent('.wpcf7').on('wpcf7mailsent', onCF7MailSent);
  });
}

function setupRedirect() {
  document.addEventListener( 'wpcf7mailsent', ( event ) => {
    const redirectUrl = event.detail.inputs.find( el => el.name === "redirect-url");

    if (redirectUrl)
      setTimeout( () => {
          location = redirectUrl.value;
      }, 1500 );
  }, false );
}

export function init() {
  onCF7MailSent();
  scrollOnSuccess();
  setupRedirect();
}
